import React from 'react';
import PropTypes from "prop-types";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import CheckboxInput from "../../../../Components/Inputs/CheckboxInput";
import CalendarOverrides from "../Inputs/CalendarOverrides";
import ConfirmationModal from "../../../../Components/Modals/ConfirmationModal";
import { showModal } from "../../../../Redux/GlobalReducer";
import { useDispatch } from "react-redux";

const MODAL_OVERRIDE_CALENDAR_UNCHECK = 'overrideCalendarUncheck'

const AvailabilityOverridesSection = (props) => {
    const dispatch = useDispatch();

    const handleOverrideCalendarCheck = (event) => {
        if (event.target.checked) {
            // If we're enabling calendar override, just allow it to be checked
            props.onChange(event.target.name, event.target.checked)
        } else {
            // Otherwise, warn user about the potential consquences
            dispatch( showModal(MODAL_OVERRIDE_CALENDAR_UNCHECK) );
        }
    }

    return (<>
        <FormRow
            label="Override Calendar"
            errorMessage={props.errors.overrides}
            className="align-middle margin-top-1"
            leftCellClassName="cell small-12 medium-4"
            rightCellClassName="cell small-12 medium-3 text-right"
        >
            <CheckboxInput
                name="override_calendar"
                checked={props.config.override_calendar}
                onChange={handleOverrideCalendarCheck}
            />
        </FormRow>

        { props.config.override_calendar &&
            <CalendarOverrides
                onChange={props.onChange}
                config={props.config}
                errors={props.errors}
            />
        }

        <ConfirmationModal
            modalKey={MODAL_OVERRIDE_CALENDAR_UNCHECK}
            title="Remove Calendar Overrides"
            message={`If you uncheck this option, all existing calendar overrides for this config will be deleted. There are currently ${Object.keys(props.config.overrides).length ?? 0} days with overrides configured.`}
            onConfirm={ (e) =>
                props.onChanges({
                    override_calendar: false,
                    overrides: []
                })
            }
            animateOnConfirm
        />
    </>);
};

AvailabilityOverridesSection.propTypes = {
    config: PropTypes.object,
    errors: PropTypes.object,
    onChange: PropTypes.func,
    onChanges: PropTypes.func
};

AvailabilityOverridesSection.defaultProps = {};

export default AvailabilityOverridesSection;
